import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-step-pagamento',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    InputNumberModule,
    ButtonModule,
    TableModule,
    TooltipModule
  ],
  templateUrl: './step-pagamento.component.html'
})
export class StepPagamentoComponent {
  @Input() parentForm!: FormGroup;
  @Input() typePaymentOptions: { label: string; value: number }[] = [];

  get paymentsArray(): FormArray {
    return this.parentForm?.get('payments') as FormArray;
  }

  get totalPaid(): number {
    const arr = this.paymentsArray;
    if (!arr) return 0;
    return arr.controls.reduce((sum, c) => {
      const v = (c as FormGroup).get('value')?.value;
      return sum + (Number(v) || 0);
    }, 0);
  }

  get totalPaidFormatted(): string {
    return this.totalPaid.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  addPayment(): void {
    this.paymentsArray.push(
      new FormGroup({
        typePaymentId: new FormControl<number | null>(null),
        value: new FormControl<number>(0)
      })
    );
  }

  removePayment(index: number): void {
    if (this.paymentsArray.length > 1) {
      this.paymentsArray.removeAt(index);
    }
  }
}
